export const MEDIA_TYPE_VIDEO = "video";
export const MEDIA_TYPE_IMAGE = "image";
export const THEME_TYPE_LIGHT = "light";
export const THEME_TYPE_DARK = "dark";
export const THEME_STORAGE_KEY = "theme-preference";
